interface Props {
  width: number
  height: number
  intervals: number
  cellHeight: number
}

export const TimeLabels = ({ width, height, intervals, cellHeight }: Props) => (
  <div className="time-labels">
    <svg width={width} height={height}>
      {[...Array(intervals)].map((_, i) => {
        const hour = i % 24
        const label = i === 24 ? '00:00' : `${String(hour).padStart(2, '0')}:00`
        return (
          <text
            key={i}
            x={width - 8}
            textAnchor="end"
            y={i * cellHeight + 14}
            fontSize="14"
            fill={i % 2 === 0 ? 'black' : 'var(--gray-tertiary)'}
            className="time-label"
          >
            {label}
          </text>
        )
      })}
    </svg>
  </div>
)
